import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Breadcrumbs, Typography, Button } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';

const MediaBreadcrumbs = function MediaBreadcrumbs({
  collectionName = '',
  closeCollection = () => {},
}) {
  const intl = useIntl();

  return (
    <Breadcrumbs
      id="media-breadcrumbs"
      aria-label="collection media breadcrumbs"
      sx={{ pl: '36px', display: !collectionName && 'none' }}
    >
      <Button
        id="returnToCustomerList-btn"
        variant="text"
        sx={{
          textTransform: 'none',
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
        onClick={closeCollection}
        color="inherit"
        size="small"
        startIcon={<ArrowBackRoundedIcon />}
      >
        {intl.messages.MEDIA}
      </Button>
      <Typography
        variant="subtitle2"
        sx={{
          color: "primary.main",
          textTransform: 'capitalize'
        }}>
        {collectionName}
      </Typography>
    </Breadcrumbs>
  );
};

MediaBreadcrumbs.propTypes = {
  collectionName: PropTypes.string,
  closeCollection: PropTypes.func,
};

export default MediaBreadcrumbs;
